<template>
<main class="home">
  <div class="showcase">
    <siema ref="siema" :loop="true">
      <div v-for="project in home" :key="project.num + '-' + project.uid" class="project">
        <Vue100vh>
          <router-link :to="{ name: 'project', params: { id: project.uid } }">
            <img :src="project.url" :alt="project.title" />
            <div class="project-title">
              <txt :phrase="project.title" />
            </div>
          </router-link>
        </Vue100vh>
      </div>
    </siema>
    <div>
      <a class="prev" @click="prev">
        <txt phrase="Previous" /></a>
      <a class="next" @click="next">
        <txt phrase="Next" /></a>
    </div>
  </div>
</main>
</template>

<script>
import Vue100vh from 'vue-div-100vh'
const Txt = () => import( /* webpackChunkName: "Text" */ '@/components/TableText.vue')
import {
  mapState
} from 'vuex'
export default {
  name: 'home',
  metaInfo() {
    return {
      title: this.site.title,
      titleTemplate: null
    }
  },
  components: {
    Txt,
    Vue100vh
  },
  data() {
    return {
      swiperOption: {
        slidesPerView: 'auto',
        mousewheel: {
          forceToAxis: true,
          invert: true,
          releaseOnEdges: true,
        },
        keyboard: {
          enabled: true,
        },
      }
    }
  },
  created() {
    this.$store.dispatch('loadInfo');
  },
  computed: {
    ...mapState(['site', 'home']),
  },
  methods: {
    prev() {
      this.$refs.siema.prev();
    },
    next() {
      this.$refs.siema.next();
    },
  }
}
</script>

<style lang="scss" scoped>
.home {
    padding-left: 0 !important;
    padding-right: 0 !important;
    .showcase {
        height: 100%;
        .siema {
            height: 100%;
        }
        .next,
        .prev {
            position: absolute;
            bottom: 0;
            cursor: pointer;
            width: 33%;
            height: calc(100vh - (3 * var(--lh)));
            opacity: 0;
            display: flex;
            align-items: flex-end;
            padding: var(--lh);
            transition: opacity 0.5s;
            &:hover {
                opacity: 1;
            }
        }
        .next {
            right: 0;
            justify-content: flex-end;
            cursor: e-resize;
        }
        .prev {
            left: 0;
            cursor: w-resize;
        }
        @media only screen and (max-width:768px) {
            .next,
            .prev {
                display: none;
            }
        }
        .project {
            height: calc(100vh - calc(4 * var(--lh)));
            width: 100%;
            text-align: center;
            position: relative;
            box-sizing: border-box;
            overflow: hidden;
            padding: 0 var(--lh);
            @media only screen and (max-width:1024px) {
                height: calc(100vh - (5 * var(--lh)));
            }
            @media only screen and (max-width:768px) {
                height: calc(100vh - (5 * var(--lh)));
            }
            a {
                width: 100%;
                display: inline-block;
                height: 100%;
                text-align: center;
                position: relative;
                // padding: 0 var(--lh);
                img {
                    width: 100%;
                    display: block;
                    object-fit: contain;
                    height: calc(100% - (6 * var(--lh)));
                    z-index: 1;
                    @media only screen and (max-width:1024px) {
                        height: calc(100% - (7 * var(--lh)));
                    }
                }
            }
            .project-title {
                padding-top: var(--lh);
                z-index: 0;
            }

        }
    }
}
</style>
